import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"text-align":"center","margin-top":"50px","margin-bottom":"50px","width":"100%"}
}
const _hoisted_2 = { class: "row full-width" }
const _hoisted_3 = {
  style: `margin-top: -2px;`,
  class: "row full-width"
}
const _hoisted_4 = { class: "q-my-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner_dots = _resolveComponent("q-spinner-dots")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_address_selector = _resolveComponent("address-selector")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_tag_selector = _resolveComponent("tag-selector")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_card, {
    style: _normalizeStyle(`width: 280px; min-height: 200px; margin-left: ${
  _ctx.marginx}px !important; margin-right: ${-_ctx.marginx}px !important; margin-bottom: ${
  -_ctx.marginy}px !important; margin-top: ${_ctx.marginy}px !important;`)
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_q_spinner_dots, {
              color: "primary",
              size: "2em"
            })
          ]))
        : (_openBlock(), _createBlock(_component_q_card_section, {
            key: 1,
            style: {"min-height":"25vh","opacity":"0.9"},
            class: "full-width"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_input, {
                outlined: "",
                dense: "",
                ref: "person_name_input",
                color: "primary",
                clearable: "",
                "clear-icon": "arrow_back",
                class: "full-width thin-input",
                modelValue: _ctx.personName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.personName) = $event)),
                "hide-bottom-space": "",
                placeholder: _ctx.$t('name_short'),
                autofocus: "",
                style: {"margin-bottom":"3px"},
                debounce: "100",
                onClear: _cache[1] || (_cache[1] = ($event: any) => (_ctx.personName = ''))
              }, null, 8, ["modelValue", "placeholder"]),
              _createVNode(_component_q_input, {
                outlined: "",
                dense: "",
                clearable: "",
                "clear-icon": "arrow_back",
                ref: "person_pos_input",
                color: "primary",
                class: "full-width thin-input",
                modelValue: _ctx.personPosition,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.personPosition) = $event)),
                "hide-bottom-space": "",
                placeholder: _ctx.$t('position'),
                style: {"margin-bottom":"3px"},
                debounce: "100",
                onClear: _cache[3] || (_cache[3] = ($event: any) => (_ctx.personPosition = ''))
              }, null, 8, ["modelValue", "placeholder"]),
              _createVNode(_component_q_input, {
                outlined: "",
                dense: "",
                multiline: "",
                autogrow: "",
                "clear-icon": "arrow_back",
                ref: "person_contact_input",
                color: "primary",
                class: "full-width thin-input-autogrow",
                modelValue: _ctx.personContacts,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.personContacts) = $event)),
                "hide-bottom-space": "",
                style: {"margin-bottom":"3px"},
                placeholder: _ctx.$t('contact_info'),
                debounce: "100",
                onClear: _cache[5] || (_cache[5] = ($event: any) => (_ctx.personContacts = ''))
              }, null, 8, ["modelValue", "placeholder"]),
              _createVNode(_component_address_selector, {
                modelValue: _ctx.AddressModel,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.AddressModel) = $event)),
                onChainSelected: _ctx.updateChain,
                "use-required": true,
                larger: true,
                "show-clear": true
              }, null, 8, ["modelValue", "onChainSelected"]),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_q_btn, {
                    class: "q-my-none q-pa-none",
                    flat: "",
                    dense: "",
                    color: "grey-7",
                    "aria-label": _ctx.$t('save'),
                    icon: _ctx.checkIcon,
                    size: "11px",
                    onClick: _ctx.performAction
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, { delay: 1000 }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('save')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["aria-label", "icon", "onClick"]),
                  _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                    class: "q-my-none q-pa-none",
                    flat: "",
                    dense: "",
                    color: "grey-7",
                    "aria-label": _ctx.$t('cancel'),
                    icon: "arrow_back",
                    size: "11px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, { delay: 1000 }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["aria-label"])), [
                    [_directive_close_popup]
                  ]),
                  _createVNode(_component_q_btn, {
                    class: "q-my-none q-pa-none",
                    flat: "",
                    dense: "",
                    color: "grey-7",
                    "aria-label": _ctx.$t('tags'),
                    icon: _ctx.poundIcon,
                    size: "11px",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectorModel = true))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, { delay: 1000 }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('tags')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["aria-label", "icon"]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tagsModel, (tag, ri) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "row no-wrap",
                      key: ri,
                      style: {"float":"left","margin-right":"5px","font-size":"14px !important"}
                    }, [
                      _createElementVNode("div", _hoisted_4, _toDisplayString(tag.Name.toLowerCase()), 1),
                      _createVNode(_component_q_btn, {
                        class: "q-pa-none q-ma-none",
                        flat: "",
                        dense: "",
                        "aria-label": _ctx.$t('remove'),
                        icon: "close",
                        size: "sm",
                        onClick: () => { _ctx.tagsModel = _ctx.tagsModel.filter((el, index) => index != ri) }
                      }, null, 8, ["aria-label", "onClick"])
                    ]))
                  }), 128))
                ]),
                _createVNode(_component_q_select, {
                  "label-slot": false,
                  "bottom-slots": false,
                  flat: "",
                  dense: "",
                  outlined: "",
                  ref: "tags_field",
                  class: "no-select-border q-mb-xs",
                  label: "",
                  modelValue: _ctx.tagsModel,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.tagsModel) = $event)),
                  "use-input": "",
                  "hide-bottom-space": "",
                  "fill-input": "",
                  multiple: "",
                  autofocus: "",
                  "option-label": "Name",
                  "option-value": "Id",
                  onInputValue: _ctx.inputFilter,
                  onNewValue: _ctx.addTextTag,
                  style: 'max-width: 40vw; max-height: 0; overflow: hidden;',
                  "input-debounce": "500",
                  "hide-dropdown-icon": true
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_menu, {
                      fit: "",
                      "no-focus": "",
                      modelValue: _ctx.selectorModel,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectorModel) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_input, {
                          outlined: "",
                          dense: "",
                          ref: "tag_search_input",
                          color: "white",
                          class: "full-width thin-input q-my-auto",
                          modelValue: _ctx.filter_string,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filter_string) = $event)),
                          "hide-bottom-space": "",
                          placeholder: _ctx.$t('search_by_tags'),
                          debounce: "100"
                        }, null, 8, ["modelValue", "placeholder"]),
                        _createVNode(_component_tag_selector, {
                          filter_string: _ctx.filter_string,
                          modelValue: _ctx.tagsModel,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.tagsModel) = $event))
                        }, null, 8, ["filter_string", "modelValue"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "onInputValue", "onNewValue"])
              ])
            ]),
            _: 1
          }))
    ]),
    _: 1
  }, 8, ["style"]))
}